<div>
  <!-- Left Sidebar -->
  <aside id="leftsidebar" class="sidebar" (mouseenter)="mouseHover()" (mouseleave)="mouseOut()">
    <!-- Menu -->
    <div class="menu">
      <ng-scrollbar [style.height]="listMaxHeight + 'px'" visibility="hover">
        <ul class="list">
          <!-- <div class="sidebar-logo" style="text-align: center; padding: 15px 0;">
            <img src="./../../../assets/easy_assets/dashboard logo.png" alt="Dashboard Logo"
              style="height: 45px; max-width: 100%;" />
          </div> -->
          <li class="sidebar-user-panel">
            <div class="user-panel">
              <div class=" image profile-img">
                <img src={{userImg}} class="img-circle user-img-circle" alt="User Image" />
              </div>
            </div>
            <div class="profile-usertitle">
              <div class="sidebar-userpic-name">
                <h5>{{userFullName}}</h5>
              </div>
              <div class="role-badges mb-3 d-flex justify-content-center">
                @for (role of filteredRoles; track filteredRoles; let i = $index) {
                <span class="role-names">{{ checkUserRoles(role) }}</span>
                @if (i < (filteredRoles?.length ?? 0) - 1) { <span><mat-divider class="divider-cls" [vertical]="true"></mat-divider></span>
                  }
                  }
              </div>

              
              <!-- <div class="role-badges mb-3">
                @for(role of userRole; track userRole){
                  <p>{{capitalizeUserRoles(role)}}</p>
                  <span class="badge badge-custom-size" [ngClass]="checkUserRoles(role)">
                    {{capitalizeUserRoles(role)}}
                  </span>
                }
              </div> -->
              
              <!-- <div class="profile-usertitle-job mb-3">

                {{userRole}} </div> -->
            </div>
          </li>
          @if(isSidebarCollapsed){
          <li>
            <div class="user-circle-image-container">
              <div class="user-image-box">
                <div class="menu-top d-flex user-image-circle">
                  <img src='{{userImg}}' class="user_img" alt="User">
                </div>
              </div>
            </div>
          </li>
          }

          @if (sidebarItems.length>0) {
          <!-- Top Most level menu -->
          @for (sidebarItem of sidebarItems; track sidebarItem.title) {

          @if(!sidebarItem.isHide){
          <li [routerLinkActive]="sidebarItem.submenu.length !== 0 ? 'active' : 'active-top'" [ngClass] = "{'submenu-active': isSubmenuActive(sidebarItem)}">
            @if (sidebarItem.groupTitle === true) {
            <div class="header">{{sidebarItem.title | translate}}</div>
            }
            @if (!sidebarItem.groupTitle;) {
            <a [routerLink]="sidebarItem.class === '' ? [sidebarItem.path] : null" [ngClass]="[sidebarItem.class]"
              (click)="callToggleMenu($event, sidebarItem.submenu.length)" class="menu-top d-flex align-items-center">
              @if(sidebarItem.iconType){
              <i [ngClass]="[sidebarItem.iconType]">{{sidebarItem.icon}}</i>
              }
              @else{
              <img [src]="getSidebarIcon(sidebarItem)" [ngClass]="{
                                                'sidebar-icon-collapsed': isSidebarCollapsed,
                                                'sidebar-icon-normal': !isSidebarCollapsed
                                              }" alt="">
              }
              <span class="hide-menu">{{sidebarItem.title | translate}}
              </span>
              @if (sidebarItem.badge !== '' ) {
              <span [ngClass]="[sidebarItem.badgeClass]">{{sidebarItem.badge}}</span>
              }
            </a>
            }
            <!-- First level menu -->
            @if (sidebarItem.submenu.length > 0) {

            <ul class="ml-menu">
              @for (sidebarSubItem1 of sidebarItem.submenu; track sidebarSubItem1) {
              @if(!sidebarSubItem1.isHide){
              <li [routerLinkActive]="sidebarSubItem1.submenu.length > 0 ? '' : 'active'">
                <div class="submenu-item-container">
                  <a [routerLink]="sidebarSubItem1.submenu.length > 0 ? null : [sidebarSubItem1.path]"
                    (click)="callToggleMenu($event,sidebarSubItem1.submenu.length)" [ngClass]="[sidebarSubItem1.class]">
                    {{sidebarSubItem1.title | translate}}
                  </a>
                </div>
                <!-- Second level menu -->
                @if (sidebarSubItem1.submenu.length > 0) {
                <ul class="ml-menu-2">
                  @for (sidebarSubItem2 of sidebarSubItem1.submenu; track sidebarSubItem2) {
                  @if(!sidebarSubItem2.isHide){
                  <li [routerLinkActive]="sidebarSubItem2.submenu.length > 0 ? '' : 'active'">
                    <a [routerLink]="sidebarSubItem2.submenu.length > 0 ? null : [sidebarSubItem2.path]"
                      (click)="callToggleMenu($event,sidebarSubItem2.submenu.length)"
                      [ngClass]="[sidebarSubItem2.class]">
                      {{sidebarSubItem2.title | translate}}
                    </a>
                    <!-- Third level menu -->
                    @if (sidebarSubItem2.submenu.length > 0) {
                    <ul class="ml-menu-3">
                      @for (sidebarSubItem3 of sidebarSubItem2.submenu; track sidebarSubItem3) {
                      @if(!sidebarSubItem3.isHide){
                      <li [routerLinkActive]="sidebarSubItem3.submenu.length > 0 ? '' : 'active'">
                        <a [routerLink]="sidebarSubItem3.submenu.length > 0 ? null : [sidebarSubItem3.path]"
                          (click)="callToggleMenu($event,sidebarSubItem3.submenu.length)"
                          [ngClass]="[sidebarSubItem3.class]">
                          {{sidebarSubItem3.title | translate}}
                        </a>
                      </li>
                      }

                      }
                    </ul>
                    }
                  </li>
                  }
                  }
                </ul>
                }
              </li>
              }
              }
            </ul>
            }
          </li>
          }

          }

          }
          <li>
            <a class="" (click)="logout()" class="menu-top d-flex align-items-center">
              <img src='./../../../assets/images/icons/Logout.svg' [ngClass]="{
                    'sidebar-icon-collapsed': isSidebarCollapsed,
                    'sidebar-icon-normal': !isSidebarCollapsed
                  }">
              <span class="hide-menu">Logout
              </span>
            </a>
          </li>
        </ul>
      </ng-scrollbar>
    </div>
    <!-- #Menu -->
  </aside>
  <!-- #END# Left Sidebar -->
</div>